import { applicationState } from '@/states/applicationState';
import ArkasLogo from '@/assets/images/ArkasLogo.svg';
import classnames from 'classnames';
import commonResources from '@/common/resources/common';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import React from 'react';

interface AppHeaderTitleProps {
  isSmallScreen: boolean;
}

/**
 * AppHeaderTitle Component
 */
const AppHeaderTitle: React.SFC<AppHeaderTitleProps> = props => {
  const { isSmallScreen } = props;
  return (
    <div className={classnames('header-logo-title', isSmallScreen && 'mobile')}>
      <Link to="/">
        <div className="header-logo">
          <ArkasLogo />
        </div>
        {!isSmallScreen && (
          <h1 className="header-title">
            <FormattedMessage id={commonResources.emutabakat.id} />
          </h1>
        )}
      </Link>
    </div>
  );
};

const mapStateToProps = (state: applicationState) => {
  return { isSmallScreen: state.appModel.isSmallScreen };
};

export default connect(mapStateToProps)(AppHeaderTitle);
